import { render, staticRenderFns } from "./FactoringContractTermsListItem.vue?vue&type=template&id=5a31d088&scoped=true&lang=pug&"
import script from "./FactoringContractTermsListItem.vue?vue&type=script&lang=js&"
export * from "./FactoringContractTermsListItem.vue?vue&type=script&lang=js&"
import style0 from "./FactoringContractTermsListItem.vue?vue&type=style&index=0&id=5a31d088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31d088",
  null
  
)

export default component.exports